// src/supabase-config.js — canonical Supabase client for the bundled build.
//
// This is the single source of truth for the Supabase client + auth options
// used by the production bundle (web `dist/` and Capacitor iOS). The dev
// path (root `index.html`) still uses the UMD `supabase-config.js` at the
// repo root, which mirrors the same `auth` options for parity.
//
// Platform split:
//   - Web (browser):    detectSessionInUrl = true  → Supabase parses the
//                       recovery/magic-link hash from window.location.
//   - Capacitor native: detectSessionInUrl = false → the WebView never
//                       receives the redirect URL directly; the deep-link
//                       listener in app.jsx (vital://reset?...) parses the
//                       tokens and calls sb.auth.setSession() manually.
//
// Capacitor injects `globalThis.Capacitor` at WebView load time, so we can
// read it here without importing `@capacitor/core` (which isn't installed
// yet during this Step 2 of the migration).

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = 'https://iyrxakaiowiilphxzyuq.supabase.co';
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml5cnhha2Fpb3dpaWxwaHh6eXVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1NTY2OTcsImV4cCI6MjA5NDEzMjY5N30.rNcAsV1GK0GOWVjZzpYD5LNDx_KjoZkFOxs8fk3R9sA';

// RevenueCat PUBLIC SDK key for iOS. Safe to ship — it can only read offerings
// and start a purchase on this device. The SECRET key (`sk_…`) lives ONLY in
// the iap-verify edge function's env.
//
// ‼️ THIS FILE AND THE ROOT supabase-config.js ARE TWINS and must define the
// same constants. The bundle (iOS + deployed web) reads THIS one; the browser
// dev loop reads the root one. Setting the key in only the root file is exactly
// how the Profile → Vital Pro row went missing from the built app while working
// in the dev loop: PurchaseAPI.isSupported() reads globalThis.REVENUECAT_PUBLIC_KEY,
// which was undefined in the bundle. build.mjs now compares the two files and
// fails on drift.
const REVENUECAT_PUBLIC_KEY = 'appl_zWQNEehlkshQcqhXJNEzAlRHZrl';

const isNative = !!globalThis.Capacitor?.isNativePlatform?.();

// Snapshot the launch URL's auth params BEFORE createClient runs. On web,
// detectSessionInUrl=true parses the recovery/magic-link hash, installs the
// session, AND strips the hash from window.location — all asynchronously
// during client init, before app.jsx's bootstrap effect runs. By then the
// hash is gone, so app.jsx can no longer tell a password-recovery link apart
// from a normal sign-in and would log the user straight in instead of opening
// the reset-password screen. We snapshot the raw strings here; app.jsx reads
// the snapshot to decide routing. (No-op on native — the WebView launches
// with an empty location and recovery arrives via the vital:// deep link.)
try {
  window.__VITAL_LAUNCH_AUTH__ = {
    hash: window.location.hash || '',
    search: window.location.search || '',
  };
} catch (_) {}

window.sb = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !isNative,
  },
});

// Exposed for PurchaseAPI (data.js). Empty string = subscriptions disabled.
window.REVENUECAT_PUBLIC_KEY = REVENUECAT_PUBLIC_KEY;
